import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDate } from "@/lib/format";
import PageHeader from "@/components/PageHeader";
import DataTable from "@/components/DataTable";
import StatusBadge from "@/components/StatusBadge";

export default function ReportAttendance() {
  const [rows, setRows] = useState([]);
  const [emps, setEmps] = useState({});
  const [projs, setProjs] = useState({});

  useEffect(() => {
    api.get("/attendance").then((r) => setRows(r.data));
    api.get("/employees").then((r) => setEmps(Object.fromEntries(r.data.map((e) => [e.id, e.nama]))));
    api.get("/projects").then((r) => setProjs(Object.fromEntries(r.data.map((p) => [p.id, p.nama]))));
  }, []);

  const columns = [
    { key: "tanggal", label: "Tanggal", sortable: true, render: (r) => formatDate(r.tanggal) },
    { key: "employee_id", label: "Pegawai", sortable: true, sortValue: (r) => emps[r.employee_id], render: (r) => emps[r.employee_id] || "-" },
    { key: "project_id", label: "Proyek", render: (r) => projs[r.project_id] || "-" },
    { key: "status", label: "Status", render: (r) => <span className="text-xs font-semibold">{r.status}</span> },
    { key: "jam_masuk", label: "Masuk" },
    { key: "jam_pulang", label: "Pulang" },
    { key: "jam_lembur", label: "Lembur", align: "right" },
    { key: "keterangan", label: "Keterangan" },
  ];
  return (
    <div className="space-y-6">
      <PageHeader title="Laporan Absensi" subtitle="Seluruh riwayat absensi pegawai" />
      <DataTable columns={columns} data={rows} searchKeys={[]} pageSize={15} testid="rep-att-table"
        toolbar={<span className="text-sm text-slate-500">{rows.length} record</span>} />
    </div>
  );
}
